import GtmHelper from './google-tag-manager'
import i18n from '@/i18n'

import { createLogger } from './log'

import {
  StoreEvents,
  storeEventLister,
  routeEventListener,
  manualEventListener,
} from './event-dispatcher'

const logger = createLogger("GTM-Subscriber", "📊", false)

export const createGTMListeners = (config, gtm) => {
  let subscribers = []
  if (config) {
    //track home page
    subscribers.push(
      routeEventListener('home', t => {
        logger.print('visited home', t)
        if (config.mode === 'ua') {
          gtm.trackEvent({
            pageCategory: 'homepage',
            visitorType: 'high-value',
          })
        } else {
          gtm.trackEvent({
            pageCategory: 'homepage',
            visitorType: 'high-value',
          })
        }
      }),
    )

    //track product impression
    subscribers.push(
      storeEventLister(StoreEvents.SEARCH_PRODUCTS_UPDATED, m => {
        const products = m.payload

        logger.print('SEARCH_PRODUCTS_UPDATED', products)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_product_impressions',
              visitorType: 'low-value',
              ecommerce: {
                currencyCode: 'EUR', // Local currency is optional.
                impressions: GtmHelper.getProductList(
                  config.mode,
                  config.brand,
                  products,
                ),
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_product_impressions',
              visitorType: 'low-value',
              category: 'ProductView',
              action: 'load',
              label: 'ProductView',
              ecommerce: {
                items: GtmHelper.getProductList(
                  config.mode,
                  config.brand,
                  products,
                ),
              },
            })
          }
        } catch (err) {
          logger.error('Failed SEARCH_PRODUCTS_UPDATED', err)
        }
      }),
    )

    //track offerclick
    subscribers.push(
      manualEventListener('offer_clicked', payload => {
        logger.print('clicked offerelement', payload)
        const product = payload.product

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_productClick',
              ecommerce: {
                click: {
                  actionField: {list: 'Search Results'}, // Optional list property.
                  products: [
                    GtmHelper.getProduct(config.mode, config.brand, product),
                  ],
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_select_item',
              category: 'ProductSelect',
              action: 'click',
              label: 'ProductSelect',
              ecommerce: {
                items: [
                  GtmHelper.getProduct(config.mode, config.brand, product),
                ],
              },
            })
          }
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track item view
    subscribers.push(
      storeEventLister(StoreEvents.HOTEL_OFFER_LOADED, m => {
        const offer = m.payload
        logger.print('HOTEL_OFFER_LOADED', offer, offer.variants)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_view_item',
              visitorType: 'mid-value',
              ecommerce: {
                detail: {
                  products: [
                    GtmHelper.getProductView(config.mode, config.brand, offer),
                  ],
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_view_item',
              visitorType: 'mid-value',
              category: 'ProductDetail',
              action: 'load',
              label: 'ProductDetail',
              ecommerce: {
                items: [
                  GtmHelper.getProductView(config.mode, config.brand, offer),
                ],
              },
            })
          }
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track add to cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_ADDED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_ADDED', cartItem)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_addToCart',
              ecommerce: {
                currencyCode: 'EUR',
                add: {
                  products: [
                    {
                      name: cartItem.title,
                      id: `wearetravel_${cartItem.variantId}`,
                      price: cartItem.unitPrice,
                      brand: config.brand,
                      //category: getThemes(product),
                      category: 'Urlaubsgutscheine',
                      variant: `${cartItem.parameter.nights} ${i18n.t(
                        'general.nights',
                      )}, ${cartItem.parameter.persons} ${i18n.t(
                        'general.persons',
                      )}`,
                      quantity: cartItem.quantity,
                    },
                  ],
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_add_to_cart', // Event type [default = 'interaction'] (Optional)
              category: 'Cart',
              action: 'click',
              label: 'Add to cart',
              ecommerce: {
                items: [
                  {
                    item_name: cartItem.title, // Name or ID is required.
                    item_id: `wearetravel_${cartItem.variantId}`,
                    //item_category: getThemes(product),
                    item_category: 'Urlaubsgutscheine',
                    price: cartItem.unitPrice,
                    quantity: cartItem.quantity,
                  },
                ],
              },
            })
          }
        } catch (err) {
          logger.error('Failed PRODUCT_ADDED', err)
        }
      }),
    )

    //track remove from cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_REMOVED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_REMOVED', cartItem)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_removeFromCart',
              ecommerce: {
                remove: {
                  products: [
                    {
                      //  removing a product to a shopping cart.
                      name: cartItem.title,
                      id: `wearetravel_${cartItem.variantId}`,
                      price: cartItem.unitPrice,
                      brand: config.brand,
                      //category: getThemes(product),
                      category: 'Urlaubsgutscheine',
                      variant: `${cartItem.parameter.nights} ${i18n.t(
                        'general.nights',
                      )}, ${cartItem.parameter.persons} ${i18n.t(
                        'general.persons',
                      )}`,
                      quantity: cartItem.quantity,
                    },
                  ],
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_remove_from_cart',
              category: 'Cart',
              action: 'click',
              label: 'Remove from cart',
              ecommerce: {
                items: [
                  {
                    item_name: cartItem.title, // Name or ID is required.
                    item_id: `wearetravel_${cartItem.variantId}`,
                    price: cartItem.unitPrice,
                    item_variant: `${cartItem.parameter.nights} ${i18n.t(
                      'general.nights',
                    )}, ${cartItem.parameter.persons} ${i18n.t(
                      'general.persons',
                    )}`,
                    //item_category: getThemes(product),
                    item_category: 'Urlaubsgutscheine',
                    item_brand: config.brand,
                    quantity: cartItem.quantity,
                  },
                ],
              },
            })
          }
        } catch (err) {
          logger.error('Failed PRODUCT_REMOVED', err)
        }
      }),
    )

    //track start checkout
    subscribers.push(
      manualEventListener('checkout_clicked', m => {
        const cartItems = m

        logger.print('CHECKOUT_PAYMENT_STARTED', cartItems)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_checkout',
              visitorType: 'high-value',
              ecommerce: {
                checkout: {
                  //actionField: {step: 1, option: 'Visa'},
                  products: GtmHelper.getCartList(
                    config.mode,
                    config.brand,
                    cartItems,
                  ),
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_begin_checkout',
              visitorType: 'high-value',
              category: 'Checkout',
              action: 'click',
              label: 'Checkout',
              ecommerce: {
                items: GtmHelper.getCartList(
                  config.mode,
                  config.brand,
                  cartItems,
                ),
              },
            })
          }
        } catch (err) {
          logger.error('Failed CHECKOUT_PAYMENT_STARTED', err)
        }
      }),
    )

    //track purchase
    subscribers.push(
      storeEventLister(StoreEvents.CHECKOUT_ORDER_CLOSED, m => {
        const order = m.payload

        logger.print('CHECKOUT_ORDER_CLOSED', order)

        try {
          if (config.mode === 'ua') {
            gtm.trackEvent({
              event: 'eec_purchase',
              ecommerce: {
                purchase: {
                  actionField: {
                    id: `wearetravel_${order.id}`, // Transaction ID. Required for purchases and refunds.
                    revenue: order.orderItems.reduce(
                      (a, c) => a + c.total,
                      0.0,
                    ), // Total transaction value (incl. tax and shipping)
                  },
                  products: GtmHelper.getPurchasedList(
                    config.mode,
                    config.brand,
                    order.orderItems,
                  ),
                },
              },
            })
          } else {
            gtm.trackEvent({
              event: 'eec_purchase',
              category: 'Purchase',
              action: 'click',
              label: 'Purchase',
              ecommerce: {
                purchase: {
                  transaction_id: `wearetravel_${order.id}`,
                  value: order.orderItems.reduce((a, c) => a + c.total, 0.0),
                  currency: order.currency,
                  items: GtmHelper.getPurchasedList(
                    config.mode,
                    config.brand,
                    order.orderItems,
                  ),
                },
              },
            })
          }
        } catch (err) {
          logger.error('Failed ORDER_CLOSED', err)
        }
      }),
    )
  }
  return subscribers
}
